var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.979,
    height: 40.993,
    viewBox: "0 0 40.979 40.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call",
    transform: "translate(-467.007 -1059.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_11",
    "data-name": "Subtraction 11",
    d: "M18.81,1.109a1.826,1.826,0,0,1,3.359,0l0,0a1.826,1.826,0,0,0,3.036.506h0a1.826,1.826,0,0,1,3.178,1.088v.019a1.826,1.826,0,0,0,2.707,1.462l0,0a1.826,1.826,0,0,1,2.653,2.058l-.009.035a1.826,1.826,0,0,0,2.084,2.26l.019,0a1.826,1.826,0,0,1,1.84,2.807l-.027.04A1.826,1.826,0,0,0,38.894,14.2l.036.006a1.826,1.826,0,0,1,.826,3.252l-.041.031a1.826,1.826,0,0,0,.254,3.06l.043.023a1.826,1.826,0,0,1-.278,3.343l-.041.014a1.826,1.826,0,0,0-.755,2.976l.035.038a1.826,1.826,0,0,1-1.351,3.071h-.028a1.826,1.826,0,0,0-1.683,2.571l.018.04a1.826,1.826,0,0,1-2.277,2.466l-.011,0a1.826,1.826,0,0,0-2.429,1.887l0,.028a1.826,1.826,0,0,1-2.956,1.595h0a1.826,1.826,0,0,0-2.911,1l0,.011a1.826,1.826,0,0,1-3.314.551h0a1.826,1.826,0,0,0-3.078,0h0a1.826,1.826,0,0,1-3.314-.551l0-.011a1.826,1.826,0,0,0-2.911-1h0A1.826,1.826,0,0,1,9.765,37l0-.028a1.826,1.826,0,0,0-2.429-1.887l-.011,0a1.826,1.826,0,0,1-2.277-2.466l.018-.04a1.826,1.826,0,0,0-1.683-2.571H3.358a1.826,1.826,0,0,1-1.351-3.071l.035-.038a1.826,1.826,0,0,0-.755-2.976l-.041-.014a1.826,1.826,0,0,1-.278-3.343l.043-.023a1.826,1.826,0,0,0,.254-3.06l-.041-.031A1.826,1.826,0,0,1,2.05,14.2l.036-.006a1.826,1.826,0,0,0,1.236-2.812l-.027-.04a1.826,1.826,0,0,1,1.84-2.807l.019,0A1.826,1.826,0,0,0,7.237,6.28l-.009-.035A1.826,1.826,0,0,1,9.881,4.186l0,0a1.826,1.826,0,0,0,2.707-1.462V2.707A1.826,1.826,0,0,1,15.772,1.62h0a1.826,1.826,0,0,0,3.036-.506Z",
    transform: "translate(467.007 1059.998)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M6.236-10.374,5.729.155H2.042L1.535-10.374ZM3.9,6.159A2.642,2.642,0,0,1,2.053,5.53a2.063,2.063,0,0,1-.7-1.6,2.1,2.1,0,0,1,.7-1.611A2.614,2.614,0,0,1,3.9,1.678a2.583,2.583,0,0,1,1.821.64,2.1,2.1,0,0,1,.7,1.611,2.073,2.073,0,0,1-.7,1.589A2.583,2.583,0,0,1,3.9,6.159Z",
    transform: "translate(483.612 1082.989)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.4ff18568d67589450602a7bd7ea77251.svg";
export { ForwardRef as ReactComponent };